module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/carousel-arrow.0654274a.svg";